// extracted by mini-css-extract-plugin
export default {"instructions":"Instructions_instructions__zGd0N","title":"Instructions_title__D-uzl","content":"Instructions_content__rn-LL"};